// src/seo/seoConfig.js
const SITE_URL = "https://ifillip.com";

const organizationSchema = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "Bharat Clouds Private Limited",
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  brand: { "@type": "Brand", name: "iFillip" },
  sameAs: [
    // "https://www.facebook.com/ifillip",
    // "https://www.linkedin.com/company/ifillip",
    // "https://twitter.com/ifillip",
  ],
};

const websiteSchema = {
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "iFillip",
  description:
    "AI-Powered School Management System for Personalized Learning in India",
  publisher: { "@id": `${SITE_URL}/#organization` },
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/?s={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

// ═══════════════════════════════════════════
// Page-specific configurations
// ═══════════════════════════════════════════

export const seoConfig = {
  home: {
    title:
      "AI-Powered School Management System for Personalized Learning in India",
    description:
      "Upgrade your school with iFillip's AI-powered school management system for smarter academic and administrative operations, including admissions, attendance, and assessments.",
    path: "/",
    keywords:
      "school management system, AI school management, school ERP India, school admissions software, attendance management system, school assessment software, iFillip",
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        organizationSchema,
        websiteSchema,
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/#webpage`,
          url: SITE_URL,
          name: "AI-Powered School Management System for Personalized Learning in India",
          description:
            "Upgrade your school with iFillip's AI-powered school management system for smarter academic and administrative operations, including admissions, attendance, and assessments.",
          isPartOf: { "@id": `${SITE_URL}/#website` },
          about: { "@id": `${SITE_URL}/#organization` },
        },
      ],
    },
  },

  whyIfillip: {
    title: "Smart School Management System | Online Admissions & Attendance",
    description:
      "Transform school operations with iFillip, a Smart School Management System featuring an Online Admission Management System and Online Attendance System.",
    path: "/Why-iFillip",
    keywords:
      "smart school management system, online admission management system, online attendance system, school administration software, school ERP, iFillip",
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/Why-iFillip/#webpage`,
          url: `${SITE_URL}/Why-iFillip`,
          name: "Smart School Management System | Online Admissions & Attendance",
          description:
            "Transform school operations with iFillip, a Smart School Management System featuring an Online Admission Management System and Online Attendance System.",
          isPartOf: { "@id": `${SITE_URL}/#website` },
          about: { "@id": `${SITE_URL}/#software` },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: `${SITE_URL}/images/ifillip-dashboard.jpg`,
          },
        },
        websiteSchema,
        {
          "@type": "SoftwareApplication",
          "@id": `${SITE_URL}/#software`,
          name: "iFillip",
          applicationCategory: "EducationalApplication",
          applicationSubCategory: "School Management Software",
          operatingSystem: "Web, Android, iOS",
          description:
            "iFillip is a Smart School Management System with Online Admission Management System and Online Attendance System, helping schools automate academic and administrative operations.",
          featureList: [
            "Online Admission Management System",
            "Online Attendance System",
            "Student Information Management",
            "Parent-Teacher Communication",
            "AI Analytics Dashboard",
            "Adaptive Learning",
            "Academic Performance Tracking",
          ],
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "INR",
            availability: "https://schema.org/InStock",
          },
          publisher: { "@id": `${SITE_URL}/#organization` },
        },
        organizationSchema,
      ],
    },
  },

  aiSuite: {
    title: "AI Based Learning Platform with Analytics Dashboard for Schools",
    description:
      "Discover iFillip's AI Learning Platform with an AI Analytics Dashboard that provides real-time insights into student and school performance.",
    path: "/ai-suite",
    keywords:
      "AI based learning platform, AI learning platform, AI analytics dashboard for schools, student performance analytics, adaptive learning platform, personalized learning, iFillip",
    schema: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "iFillip AI Suite",
      url: `${SITE_URL}/ai-suite`,
      applicationCategory: "EducationalApplication",
      operatingSystem: "Web, Android, iOS",
      description:
        "iFillip AI Based Learning Platform with an AI Analytics Dashboard for Schools provides real-time insights into student performance, academic progress, and school-level analytics.",
      keywords: [
        "AI Based Learning Platform",
        "AI Learning Platform",
        "AI Analytics Dashboard for Schools",
        "Student Performance Analytics",
        "School Performance Dashboard",
        "Adaptive Learning Platform",
        "Personalized Learning System",
        "AI Education Software",
        "Smart School Management System",
      ],
      publisher: {
        "@type": "Organization",
        name: "Bharat Clouds Private Limited",
        url: SITE_URL,
      },
      brand: { "@type": "Brand", name: "iFillip" },
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        availability: "https://schema.org/InStock",
      },
      featureList: [
        "AI-powered personalized learning",
        "Adaptive learning recommendations",
        "AI Analytics Dashboard",
        "Real-time student performance tracking",
        "School performance analytics",
        "Teacher insights and reports",
        "Data-driven educational decision making",
      ],
      audience: {
        "@type": "EducationalAudience",
        educationalRole: [
          "Student",
          "Teacher",
          "School Administrator",
          "Parent",
        ],
      },
    },
  },

  coreFeatures: {
    title: "AI-Based Learning Platform for Schools in India | iFillip",
    description:
      "AI-powered learning platform for schools with smart dashboards, adaptive learning, online admissions, attendance, and exam management.",
    path: "/core-features",
    keywords:
      "AI based learning platform India, school management software, adaptive learning, online admissions, attendance tracking, exam management, iFillip",
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/core-features/#webpage`,
          url: `${SITE_URL}/core-features`,
          name: "AI-Based Learning Platform for Schools in India | iFillip",
          description:
            "AI-powered learning platform for schools with smart dashboards, adaptive learning, online admissions, attendance, and exam management.",
          isPartOf: { "@id": `${SITE_URL}/#website` },
          about: { "@id": `${SITE_URL}/#software` },
        },
        websiteSchema,
        {
          "@type": "SoftwareApplication",
          "@id": `${SITE_URL}/#software`,
          name: "iFillip AI-Based Learning Platform",
          applicationCategory: "EducationalApplication",
          applicationSubCategory: "School Management Software",
          operatingSystem: "Web, Android, iOS",
          description:
            "iFillip is an AI-powered school management and learning platform designed for schools in India with adaptive learning, AI analytics, online admissions, attendance tracking, and exam management.",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "INR",
            availability: "https://schema.org/InStock",
          },
          featureList: [
            "AI-Based Learning",
            "Adaptive Learning",
            "AI Analytics Dashboard",
            "Online Admission Management",
            "Online Attendance System",
            "Exam Management System",
            "Student Performance Tracking",
            "Parent Teacher Communication",
            "School Administration Management",
          ],
          creator: { "@id": `${SITE_URL}/#organization` },
        },
        organizationSchema,
        {
          "@type": "BreadcrumbList",
          "@id": `${SITE_URL}/core-features/#breadcrumb`,
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
            {
              "@type": "ListItem",
              position: 2,
              name: "Core Features",
              item: `${SITE_URL}/core-features`,
            },
          ],
        },
      ],
    },
  },
  blog: {
    title:
      "iFillip Blog | School Management, AI in Education, Ed-Tech Insights",
    description:
      "Stay updated with our latest blogs, articles on school management, AI-powered analytics, education technology, digital learning, and smarter educational administration.",
  },

  contact: {
    title: "Contact iFillip | School Management Software Support",
    description:
      "Get in touch with our team for product information, assistance, and support to transform your school.",
  },

  bookDemo: {
    title: "Book your iFillip Free Demo Consultation now",
    description:
      "Experience iFillip in action. Schedule a personalized demo and discover how your school can streamline administrative and academic activities with greater efficiency.",
  },
};

export default seoConfig;
